<dx-popup
    #updateStatusPopup
    minWidth="150px"
    minHeight="150px"
    width="35%"
    height="25%"
    title="Update Missing Bill Queue Item Id #{{ workflowMissingBill.workflowMissingBillQueueId }}"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onPopupShown()"
    (onHidden)="onPopupClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col" class="editor-box-container">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <div class="row-container">
                        <div class="field-label">Status</div>
                        <div class="field-component">
                            <dx-select-box
                                displayExpr="displayText"
                                valueExpr="key"
                                [elementAttr]="{ class: 'field-component' }"
                                [dataSource]="missingBillStatusOptions"
                                [(value)]="selectedMissingBillStatus"
                            ></dx-select-box>
                        </div>
                    </div>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <div class="row-container">
                        <div class="field-label">Resolved</div>
                        <div class="field-component">
                            <dx-select-box
                                [elementAttr]="{ class: 'field-component' }"
                                [dataSource]="modesOptions"
                                [(value)]="selectedMode"
                                (onValueChanged)="onModeOptionValueChange()"
                            ></dx-select-box>
                        </div>
                    </div>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <div class="button-row-container">
                        <div class="left-button-container">
                            <dx-button
                                [icon]="iconCancel"
                                type="default"
                                text="Cancel"
                                [tabIndex]="-1"
                                (onClick)="onPopupClose()"
                            ></dx-button>
                        </div>

                        <div class="right-button-container">
                            <dx-button
                                [icon]="iconCheck"
                                type="success"
                                text="Save"
                                [tabIndex]="-1"
                                (onClick)="onSave()"
                            ></dx-button>
                        </div>
                    </div>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
